import request from '../../../common/request/index.js'
const api = request.api

export default {
  makenewmodel: async (dbinfo, fields) => {
    return api.post(`feng/feng/makenewmodel`, { dbinfo, fields })
  },
  editnewmodel: async (dbinfo, fields) => {
    return api.put(`feng/feng/editnewmodel`, { dbinfo, fields })
  },
  getDbinfo: async (dbname) => {
    return api.get(`feng/feng/getmodelinfo/${dbname}`)
  },
  // ========== 新增 getmodelinfo 方法 ==========
  getmodelinfo: async (dbname) => {
    return api.get(`feng/feng/getmodelinfo/${dbname}`)
  },
  get: async (dbname, id) => {
    return api.get(`feng/feng/getdata/${dbname}/${id}`)
  },
  getdata: async (dbname, data) => {
    return api.post(`feng/feng/getdata/${dbname}`, data)
  },
  getDbinfoByName: async (dbname) => {
    return api.get(`feng/feng/getDbinfoByName/${dbname}`)
  },
  page: async (dbname, data) => {
    return api.post(`feng/feng/page/${dbname}`, data)
  },
  fengpage: async (dbname, data) => {
    return api.post(`feng/feng/fengpage/${dbname}`, data)
  },
  put: async (dbname, data) => {
    return api.put(`feng/feng/putdata/${dbname}`, data)
  },
  post: async (dbname, data) => {
    return api.post(`feng/feng/postdata/${dbname}`, data)
  },
  del: async (dbname, id) => {
    return api.delete(`feng/feng/deldata/${dbname}/${id}`)
  },
  delmodel: async (id) => {
    return api.delete(`feng/feng/delmodelinfo/${id}`)
  },
  restatusmodel: async (id) => {
    return api.put(`feng/feng/restatusmodel/${id}`)
  },
  orpost: async (url, data) => {
    return api.post(url, data)
  },
  alluser: async () => {
    return api.post("feng/feng/getalluser/forqk")
  },
  searchuser: async (id) => {
    return api.post(`feng/feng/searchuser/kwd`, { keyword: id })
  },
  // 充值统计
  getRechargeStatistics: async (data) => {
    return api.post(`feng/feng/recharge/tongji`, data)
  },
  exportRechargeExcel: async (data) => {
    return api.post(`feng/feng/recharge/export`, data, {
      responseType: 'blob'
    })
  },
  // 加气统计
  getOilStatistics: async (data) => {
    return api.post(`feng/feng/buyoil/tongji`, data)
  },
  exportOilExcel: async (data) => {
    return api.post(`feng/feng/buyoil/export`, data, {
      responseType: 'blob'
    })
  },
}